module.exports = __webpack_public_path__ + "img/security.08e4128c.svg";